import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';

import Panel from 'react-bootstrap/lib/Panel';

import {
  faRocket,
  faRuler,
  faList,
  faChartLine,
  faDollarSign,
} from '@fortawesome/free-solid-svg-icons';

import Link from '../../../../../components/Link';
import PageLayout from '../../../../../components/PageLayout';

import ShadowerLink from '../../../../../components/ShadowerLink';

import Navbar from '../../../../../components/Handbook/Navbar';

import s from '../../HandbookPage.scss';

class SessionTypePage extends React.Component {
  render() {
    return (
      <PageLayout className={s.page}>
        <div className={s.container}>
          <div className={s.navbar}>
            <div className={s.title}>Shadowing Handbook</div>
            <Navbar
              navbarIcon={faRocket}
              navbarSection="Getting Started"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/welcome-to-shadower"
                  >
                    Welcome to Shadower
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/how-shadower-works"
                  >
                    How Shadower Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/working-with-businesses"
                  >
                    Working with Businesses
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/shadowing-guidelines"
                  >
                    Shadowing Guidelines
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faRuler}
              navbarSection="Planning a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/choosing-a-topic"
                  >
                    Choosing a Topic
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/interactivity-level"
                  >
                    Interactivity Level
                  </Link>
                  <Link
                    className={cx(s.link, s.active)}
                    to="/handbook/planning-a-session/session-type"
                  >
                    Session Type
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/providing-resources"
                  >
                    Providing Resources
                  </Link>
                </div>
              }
              overrideDefault
            />

            <Navbar
              navbarIcon={faList}
              navbarSection="Managing a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/expectations"
                  >
                    Expectations
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/session-flow"
                  >
                    Session Flow
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/maximizing-your-time"
                  >
                    Maximizing Your Time
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faChartLine}
              navbarSection="Promoting Your Profile"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-the-platform-works"
                  >
                    How the Platform Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/optimizing-your-profile"
                  >
                    Optimizing Your Profile
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/marketing-yourself"
                  >
                    Marketing Yourself
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-to-build-a-following"
                  >
                    How to Build a Following
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faDollarSign}
              navbarSection="Earning Revenue"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/how-payment-works"
                  >
                    How Payment Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/connecting-with-the-community"
                  >
                    Connecting with the Community
                  </Link>
                </div>
              }
            />

            <Link className={s.newProfileLink} to="/user/profiles/new">
              Create a shadowing profile
            </Link>
          </div>

          <div className={s.explanation}>
            <Panel>
              <Panel.Heading>
                <div>Planning a Session</div>
              </Panel.Heading>
              <Panel.Body>
                <div className={s.handbookTitle}>A guide for experts</div>

                <div className={s.subsectionTitle}>Session Type</div>

                <p>
                  You have a couple more options when it comes to the type of
                  sessions you want to offer, such as the location and whether
                  it is public or private.
                </p>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Location</strong>
                  </div>
                  <p>
                    The shadowing session can take place in one of three
                    locations:
                  </p>

                  <ul>
                    <li>At your place of work</li>

                    <li>At your home (if you work from home)</li>

                    <li>At your shadower's home</li>
                  </ul>

                  <p>
                    In general, it is preferable for sessions to take place at
                    your office, studio or other area normally accessible to the
                    public. For concerns about safety, read our{' '}
                    <Link to="/trust-and-safety">Safety Tips</Link>.
                  </p>

                  <p>
                    If you choose for the session to take place at your
                    shadower's home, you can specify the farthest amount you are
                    willing to drive and how much extra it will cost. For
                    at-home sessions, it is expected that you bring any
                    supplies, technology or equipment necessary to facilitate a
                    successful and instructive shadowing experience.
                  </p>
                </div>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Private or Public Sessions</strong>
                  </div>

                  <p>
                    By default, one-on-one sessions are private and sessions
                    with two or more spots are public, meaning any user on the
                    site can fill those spots.
                  </p>

                  {/*    <p>
                        It is possible to create private sessions for more
                        groups of two or more people as well. In this case, the
                        first person to book a shadowing spot is the <i>only</i>{' '}
                        person who can book the remaining spots.
                      </p>

                      <p>
                        Private shadowing sessions are useful if you typically
                        prefer one-on-one sessions, but would like to offer your
                        shadower the option to bring one or two friends or
                        family members as well. This is one way to maximize your
                        time and revenue. Private sessions are also useful for
                        large private groups, workshops and classes. In this
                        case, a user will most likely contact you and you can
                        create the private session just for them.
                      </p> */}

                  <p>
                    If you feel that your area of expertise does not require
                    one-on-one attention, it might be best to make the sessions
                    public. As a general rule of thumb, it's wisest to offer
                    both types on your shadowing profile. Some users may be
                    hesitant to book a public session if they feel like they
                    won't receive your full attention.
                  </p>
                </div>

                <ShadowerLink
                  className={s.nextLink}
                  to="/handbook/planning-a-session/providing-resources"
                >
                  Next {'>'}
                </ShadowerLink>
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </PageLayout>
    );
  }
}

export default withStyles(s)(SessionTypePage);
